import { useState } from "react";
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import '../styles/autocomplete.scss';
import { useFuse } from "./useFuse";

// list should be supplied as [{id, label, desc}]

export const Autocomplete = ({ list, onSelect, placeholder, onInputActive, value, onChange, searchIcon }) => {
  const [internalValue, setInternalValue] = useState("");
  const [inputActive, setInputActive] = useState(false);
  const [mouseOverResult, setMouseOverResult] = useState(false);

  const isControlled = value !== undefined;
  const searchTerm = isControlled ? value : internalValue;

  const setSearchTerm = (nextValue) => {
    if (isControlled) {
      onChange && onChange(nextValue);
    } else {
      setInternalValue(nextValue);
    }
  };

  const searchResults = useFuse(searchTerm, list);

  const exactMatch = (query, text) => {
    const regex = new RegExp(`^${query}`, 'i');
    // console.log('running exactmatch', query, text, regex.test(text));
    return regex.test(text);
  };

  const handleOptionSelect = option => {
    console.log('handleOptionSelect', option);
    onSelect(option);
    setSearchTerm(option.label);
    setInputActive(false);
  }

  return (
    <div className={`autocomplete-container ${inputActive ? 'active' : ''} ${searchIcon ? 'has-search-icon' : ''}`}>
      <div className="search-input-wrap">
        {searchIcon ? (
          <SearchRoundedIcon className="search-input-icon" aria-hidden="true" />
        ) : null}
        <input 
          className={`search-input browser-default ${inputActive ? 'active' : ''}`}
          value={searchTerm} 
          onChange={e => setSearchTerm(e.target.value)}
          placeholder={placeholder || "Enter a search term"} 
          onClick={e => e.stopPropagation()}
          onFocus={() => {
            setInputActive(true);
            onInputActive && onInputActive();
          }}
          onBlur={() => mouseOverResult ? null : setInputActive(false)}
        />
      </div>
      <div className={`results-container ${inputActive ? 'shown' : ''}`}>
        {searchResults.slice(0, 10).map(result => (
          <button 
            class={`${exactMatch(searchTerm, result.label) ? 'exact-match' : ''} search-result`}
            onClick={e => {
              e.stopPropagation();
              handleOptionSelect(result);
            }}
            onMouseOver={() => setMouseOverResult(true)}
            onMouseLeave={() => setMouseOverResult(false)}
          >
            <span>{result.label}</span> 
            <span className="subtext">{result.desc?.length ? ` (${result.desc})` : ''}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default Autocomplete;